import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const MiscLeakSensorGlyph = /*#__PURE__*/createElement("g", {
  id: "misc_leak_sensor"
}, /*#__PURE__*/createElement("path", {
  d: "M14.33 18.74h3.69v23.43h-3.69zm51.65 0h3.69v23.43h-3.69zM51.51 48.59s-9.06 16.67 0 16.67c8.95 0 0-16.67 0-16.67zm-7.36-7.06s-6.37 11.71 0 11.71c6.29.01 0-11.71 0-11.71z"
}), /*#__PURE__*/createElement("path", {
  d: "M44.91 21.04H14.33v18.83h27.45l3.23-3H17.33V24.04h49.34v12.83H51.9l-2.01 3h19.78V21.04z"
}), /*#__PURE__*/createElement("path", {
  d: "M48.55 31.48l2.79-5.01-9.8 5.01 4.9 4.06-1.43 1.33h6.89l2.7-4.04z"
}));
const MiscLeakSensor = createSvg({
  name: 'misc_leak_sensor',
  path: MiscLeakSensorGlyph
});

export default MiscLeakSensor;
export { MiscLeakSensorGlyph };
